import {getModalStore} from "../../store/ModalStore";

export const capitalize = (str) => {
    return str && str.charAt(0).toUpperCase() + str.substring(1);
};

export const noop = () => {
};

export const SIDEBAR_LEFT_WIDTH = 240;

export const isDef = (value) => typeof value !== 'undefined';

export const isString = (value) => {
    return typeof value === 'string';
};

export function isFunction(value) {
    return typeof value === 'function';
}

export const includesSearch = (value, search) => {
    const valueLower = (value || '').toLocaleLowerCase();
    const searchLower = (search || '').toLocaleLowerCase();
    return valueLower.includes(searchLower);
}

export const parseParamsToObject = (params = '') => {
    const cleanParams = params[0] === '?' ? params.substring(1) : params;
    const urlParams = new URLSearchParams(cleanParams);
    return Object.fromEntries(urlParams);
}

export const createId = (length = 16) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const len = chars.length;
    let result = chars.charAt(Math.floor(Math.random() * (len - 10)));
    for (let i = 0; i < length - 1; i++) {
        result += chars.charAt(Math.floor(Math.random() * len));
    }
    return result;
};

/**
 * replaceJSX('Hello {PLH}!!', { PLH: <div /> })
 */
export const replaceJSX = (str, replacement) => {
    const result = [];
    const keys = Object.keys(replacement);
    const getRegExp = () => {
        const regexp = [];
        keys.forEach((key) => regexp.push(`{${key}}`));
        return new RegExp(regexp.join('|'));
    };
    str.split(getRegExp()).forEach((item, i) => {
        result.push(item, replacement[keys[i]]);
    });
    return result;
};

export const rgbToHex = (rgba, forceRemoveAlpha = false) => {
    return "#" + rgba.replace(/^rgba?\(|\s+|\)$/g, '') // Get's rgba / rgb string values
        .split(',') // splits them at ","
        .filter((string, index) => !forceRemoveAlpha || index !== 3)
        .map(string => parseFloat(string)) // Converts them to numbers
        .map((number, index) => index === 3 ? Math.round(number * 255) : number) // Converts alpha to 255 number
        .map(number => number.toString(16)) // Converts numbers to hex
        .map(string => string.length === 1 ? "0" + string : string) // Adds 0 when length of one number is 1
        .join("") // Puts the array to togehter to a string
}

export const timeout = async (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const reloadScripts = (documentWindow) => {
    const modalStore = getModalStore();
    const isEditor = modalStore.MODAL_INIT_OPENED.length === 0;
    if (!isEditor) {
        if (["SAVE_ITEM", "COMMON_BOARD_EDITOR", "PRODUCT_LIVE_SET_TIME"].includes(modalStore.MODAL_INIT_OPENED[modalStore.MODAL_INIT_OPENED.length - 1].modalProps.type)) {
            if (documentWindow["makeEventSwiperFunc"]) documentWindow["makeEventSwiperFunc"]();
            if (documentWindow["ac_swiper"]) documentWindow["ac_swiper"]();
            if (documentWindow["stopSwiper"]) documentWindow["stopSwiper"]();
        }
    } else {
        if (documentWindow["makeEventSwiperFunc"]) documentWindow["makeEventSwiperFunc"](isEditor);
        if (documentWindow["ac_swiper"]) documentWindow["ac_swiper"]();
        if (documentWindow["stopSwiper"]) documentWindow["stopSwiper"]();
    }
    if (documentWindow["initToggleTab"]) documentWindow["initToggleTab"]();
    if (documentWindow["nncolor"]) documentWindow["nncolor"]();
    if (documentWindow["colorcombi"]) documentWindow["colorcombi"]();
    if (documentWindow["prdDetail"]) documentWindow["prdDetail"]();
    if (documentWindow["sizetip"]) documentWindow["sizetip"]();
    if (documentWindow["prdDetail"]) documentWindow["prdDetail"]();
    if (documentWindow["moodboard"]) documentWindow["moodboard"]();

}